import { createContext, useContext, useReducer } from "react";
import { ICreateReportFormAction } from "../../contracts/ICreateReportFormAction";
import IReportSaveDataContext from "../../contracts/IReportSaveDataContext";

const initialCreateReportForm: IReportSaveDataContext = {
  reportName: "",
  selectedDataSource: null,
  currentAvailableColumns: [],
  reportDescription: "",
  permissions: "",
  owner: "",
  category: "",
  emailRecipients: "",
  exportData: "",
  reportSpecification: {
    filterCriterias: [],
    columnSelections: [
      {
        columnId: -1,
        columnName: "",
        columnDescription: "",
        columnDataType: "",
        formatString: null,
        aggregateFunction: "",
        orderType: "",
        groupBy: "",
      },
    ],
  },
  errors: {
    reportNameError: "",
    categoryError: "",
    permissionsError: "",
  },
};

export const CreateReportFormContext = createContext<{
  createReportForm: IReportSaveDataContext;
  dispatch: React.Dispatch<ICreateReportFormAction>;
} | null>(null);

const CreateReportFormProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [createReportForm, dispatch] = useReducer(
    createReportFormReducer,
    initialCreateReportForm
  );
  return (
    <CreateReportFormContext.Provider value={{ createReportForm, dispatch }}>
      {children}
    </CreateReportFormContext.Provider>
  );
};
export default CreateReportFormProvider;

export const createReportFormReducer = (
  state: IReportSaveDataContext,
  action: ICreateReportFormAction
) => {
  switch (action.type) {
    case "UPDATE": {
      return {
        ...state,
        ...action.payload,
      };
    }
    case "UPDATE_REPORT_SPECIFICATION": {
      return {
        ...state,
        reportSpecification: {
          ...state.reportSpecification,

          ...action.payload,
        },
      };
    }
    case "UPDATE_ERROR": {
      const { field, value } = action.payload;
      return {
        ...state,
        errors: {
          ...state.errors,
          [field]: value,
        },
      };
    }
    default:
      return state;
  }
};
